






























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thhandlewarning from "../../../store/entities/handlewarning";
import Echarts from "../../monitor/threaltimedata/Echarts.vue";
import EchartsHumi from "../../monitor/threaltimedata/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
class PageThRealTimeDataRequest extends PageRequest {
  addTime: Date=new Date();
  Mac: string;
  locationName:string;
  StartDate:Date = new Date();
  EndDate:Date=new Date();
}
@Component({
  components: { Echarts,EchartsHumi },
})

export default class Analysehandlewarning extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date}) AddTime: Date;
   @Prop({ type: String}) mac: string;
   @Prop({type:String}) locationName:string;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi:number=10;
  datalist = [];
  legenddata: string = "";
  xAxisdata: string = "";
  seriesdata: string = "";
  humiseriesdata: string = "";
  yAxisdata:string="";
  serieslist = [];
  humiserieslist = [];
  humistrtitle:string="";
  yAxislist=[];
  thhandlewarning: Thhandlewarning = new Thhandlewarning();
  StartTime: string;
  EndTime: string;
  list=[];
  strtitle:string="";
  title: string = "数据分析";
  tempmessage1: string = "";
  humimessage1: string = "";
  tempmessage2: string = "";
  humimessage2: string = "";
  tempmessage3: string = "";
  humimessage3: string = "";
  datetype:string='day';
  monthDate:Date=new Date();
  maxtemp:string ="";
  mintemp:string ="";
  maxhumi:string ="";
  minhumi:string ="";
  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    this.pagerequest.addTime=this.AddTime;
    this.pagerequest.StartDate = this.AddTime;
    this.pagerequest.EndDate = this.AddTime;
    this.pagerequest.Mac=this.mac;
    this.list=await this.$store.dispatch({
      type: "thhandlewarning/getPagedLast",
      data: this.pagerequest,
    });
    //this.ThisThPaged();
    this.strtitle='温度走势图';
    this.humistrtitle='湿度走势图';
    let titlelist = ["一号针", "二号针", "三号针"];

    this.serieslist.push(
      {
        name: "一号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      },
      {
        name: "二号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(154, 208, 128)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      },
      {
        name: "三号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "red"
          },{ 
            offset: 1,
            color: "rgba(250, 200, 88)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      }
    );
    this.humiserieslist.push(
      {
        name: "一号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      },
      {
        name: "二号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(154, 208, 128)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      },
      {
        name: "三号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "red"
          },{ 
            offset: 1,
            color: "rgba(250, 200, 88)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      }
    );

    let timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_temp1 = [];
    let datalist_humi1 = [];
    let datalist_temp2 = [];
    let datalist_humi2 = [];
    let datalist_temp3 = [];
    let datalist_humi3 = [];

    for (let entry of this.list) {
      //debugger
      // if(entry.pNo==1){
      //   timelist.push(this.GetMinutes(entry.addTime));
      //   datalist_temp1.push(entry.temp);
      //   datalist_humi1.push(entry.humi);
      // }else if(entry.pNo==2){
      //   datalist_temp2.push(entry.temp);
      //   datalist_humi2.push(entry.humi);
      // }else if(entry.pNo==3){
      //   datalist_temp3.push(entry.temp);
      //   datalist_humi3.push(entry.humi);
      // }
        timelist.push(this.GetMinutes(entry.addTime));
        datalist_temp1.push(entry.temp1);
        datalist_humi1.push(entry.humi1);
        datalist_temp2.push(entry.temp2);
        datalist_humi2.push(entry.humi2);
        datalist_temp3.push(entry.temp3);
        datalist_humi3.push(entry.humi3);
        this.maxtemp=entry.maxtemp;
        this.mintemp=entry.mintemp;
        this.maxhumi=entry.maxhumi;
        this.minhumi=entry.minhumi;
      
    }
    this.tempmessage1= datalist_temp1[datalist_temp1.length - 1];
    this.humimessage1 = datalist_humi1[datalist_temp1.length - 1];
    this.tempmessage2= datalist_temp2[datalist_temp2.length - 1];
    this.humimessage2 = datalist_humi2[datalist_temp2.length - 1];
    this.tempmessage3= datalist_temp3[datalist_temp3.length - 1];
    this.humimessage3 = datalist_humi3[datalist_temp3.length - 1];

    this.serieslist[0].data = datalist_temp1;
    this.serieslist[1].data = datalist_temp2;
    this.serieslist[2].data = datalist_temp3;

    this.humiserieslist[0].data = datalist_humi1;
    this.humiserieslist[1].data = datalist_humi2;
    this.humiserieslist[2].data = datalist_humi3;

    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.humiseriesdata = JSON.stringify(this.humiserieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }
  //  async getThreshold(){
  //   this.pagerequest.Mac = this.mac;
  //   var elist = await this.$store.dispatch({
  //     type: "thequipment/getPageBymac",
  //     data: this.pagerequest,
  //   });
  //   console.log(elist);
  //   if(elist.length > 0){
  //     var threshold = await this.$store.dispatch({
  //     type: "ththreshold/get",
  //     id: elist[0].tId,
  //   });
  //    this.maxtemp=threshold.maxtemp;
  //    this.mintemp=threshold.mintemp;
  //    this.maxhumi=threshold.maxhumi;
  //    this.minhumi=threshold.minhumi;
  //    console.log(threshold);
  //   }
  // }
 GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
   GetDays(time) {
    let date = new Date(time);
    let Str =this.GetBqMinutes(date.getMonth()+1)+"-"+this.GetBqMinutes(date.getDate()) ;
    return Str;
  }
  GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  visibleChange(value: boolean) {

    // this.ThisThPaged();

    if (!value) {
      this.$emit("input", value);
    } else {
      // this.thdata = Util.extend(
      //   true,
      //   {},
      //   this.$store.state.thdata.analyseThdata
      // );
      //console.log(this.$store.state.thdata.analyseThdata);
      this.getPage();
      // this.getThreshold();
    }
    
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi+=1;
  }

  // async ThisThPaged(){
  //  this.list=await this.$store.dispatch({
  //     type:"thdata/getThisThPaged",
  //   });
  //   //return this.list;
    
  // }
GetByDate(){
    if(this.pagerequest.StartDate.toString()!=""&&this.pagerequest.EndDate.toString()!=""){
      //  this.pagerequest.StartDate=this.startDate;
      //  this.pagerequest.EndDate=this.endDate;
       this.pagerequest.Mac = this.mac;
       this.GetPageByDate();
    }
    
  }
  GetByMonth(){
    if(this.monthDate.toString()!=""){
    var currentY = this.monthDate.getFullYear();
    var currentM = this.monthDate.getMonth()+1;
    var lastM = new Date(currentY,currentM,0);
    var lastS = new Date(currentY,currentM-1);
    this.pagerequest.StartDate=lastS;
    this.pagerequest.EndDate=lastM;
    this.pagerequest.Mac = this.mac;
    this.GetPageByDate();
    }
    
  }
  async GetPageByDate(){
    console.log(this.pagerequest);
    this.list = await this.$store.dispatch({
      type: "thhandlewarning/getPageByDate",
      data: this.pagerequest,
    });
     this.strtitle='温度走势图';
    this.humistrtitle='湿度走势图';
    let titlelist = ["一号针", "二号针", "三号针"];

     this.serieslist.push(
      {
        name: "一号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      },
      {
        name: "二号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(154, 208, 128)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      },
      {
        name: "三号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "red"
          },{ 
            offset: 1,
            color: "rgba(250, 200, 88)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      }
    );
    this.humiserieslist.push(
      {
        name: "一号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      },
      {
        name: "二号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(154, 208, 128)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      },
      {
        name: "三号针",
        type: "line",
        data: [], areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "red"
          },{ 
            offset: 1,
            color: "rgba(250, 200, 88)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      }
    );

    let timelist = [];

    let datalist_temp1 = [];
    let datalist_humi1 = [];
    let datalist_temp2 = [];
    let datalist_humi2 = [];
    let datalist_temp3 = [];
    let datalist_humi3 = [];

    for (let entry of this.list) {
        timelist.push(this.GetDays(entry.addTime));
        datalist_temp1.push(entry.temp1);
        datalist_humi1.push(entry.humi1);
        datalist_temp2.push(entry.temp2);
        datalist_humi2.push(entry.humi2);
        datalist_temp3.push(entry.temp3);
        datalist_humi3.push(entry.humi3);
      
    }

    this.serieslist[0].data = datalist_temp1;
    this.serieslist[1].data = datalist_temp2;
    this.serieslist[2].data = datalist_temp3;

    this.humiserieslist[0].data = datalist_humi1;
    this.humiserieslist[1].data = datalist_humi2;
    this.humiserieslist[2].data = datalist_humi3;

    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.humiseriesdata = JSON.stringify(this.humiserieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }
 
}
